import { lazy } from 'react';

const ChangePasswordPage = lazy(() => import('./pages/changePasswordPage'));

export const ChangePasswordEntry = () => <ChangePasswordPage />;
